import { useState } from 'react';
import { stripLeadingWhitespace } from '@nxsys/utils/textUtils';
import { StyledAppSelect } from './index.styled';

type OptionType = {
  label: string;
  value: any;
};
type OptionGroupType = {
  label: string;
  title: string;
  options: OptionType[];
};
type AppSelectOption = OptionType | OptionGroupType;

type AppSelectProps = {
  options: AppSelectOption[];
  onChange?: (value: OptionType) => void;
  defaultValue?: OptionType;
  placeholder?: string;
  allowCapitalize?: boolean;

  [x: string]: any;
};

const AppSelect = ({
  options = [],
  onChange,
  defaultValue,
  placeholder = 'Select an option',
  allowCapitalize = true,
  ...rest
}: AppSelectProps) => {
  const [selectionType, setSelectionType] = useState<any>();
  const [searchValue, setSearchValue] = useState<string>('');

  // Handle selection changes
  const handleSelection = (value: OptionType) => {
    setSelectionType(value);
    onChange && onChange(value);
  };

  // Handle search with first letter capitalization
  const handleSearch = (rawValue: string) => {
    const value = stripLeadingWhitespace(rawValue);
    if (value && value.length > 0 && allowCapitalize) {
      const capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1);
      setSearchValue(capitalizedValue);
    } else {
      setSearchValue(value);
    }
  };

  // Custom filter function that works with capitalized search
  const customFilter = (input: string, option: any) => {
    const cleaned = input.trim();
    const capitalizedInput = cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
    return option?.label
      ?.toLowerCase()
      .includes(capitalizedInput.toLowerCase());
  };

  return (
    <StyledAppSelect
      labelInValue
      size="large"
      showSearch
      allowClear
      defaultValue={defaultValue}
      placeholder={placeholder}
      value={selectionType}
      listHeight={400}
      options={options}
      onChange={(_value, option) => handleSelection(option as OptionType)}
      optionFilterProp="label"
      searchValue={searchValue}
      filterOption={customFilter}
      onSearch={handleSearch}
      {...rest}
    />
  );
};

export default AppSelect;
